// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  display: block;
  font-size: 0.9em;
  font-weight: 500;
  margin-bottom: 0.2em;
}
select {
  padding: 6px 10px;
  border: 1px solid lightgray;
  border-radius: var(--border-radius);
}
.buttonSpacer {
  width: 200px;
  display: inline-block;
  margin-bottom: 5px;
}

.buttonSpacerHalf {
  width: 100px;
  display: inline-block;
}

@media (max-width: 1000px) {
  label {
    text-align: left;
  }
  .unitslabel {
    width: 40px;
  }
  .buttonSpacer {
    width: 5px;
  }
}

.radioLabel {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 5px;
}
.radioButton {
  vertical-align: middle;
}

.unitslabel {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
}
.required {
  color: rgb(249, 0, 10, 0.7);
  margin-left: 2px;
}
.inputbox {
  border: 1px solid lightgray;
}
select.inputbox {
  padding: 2px 10px 2px 4px;
}
.checkbox-wrapper {
  margin: 5px 0 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.checkbox-wrapper label {
  color: #555;
}

.calctooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
  margin-left: 4px;
  cursor: pointer;
}

.calctooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: #f4f5fa;
  color: black;
  text-align: center;
  border-radius: var(--border-radius);
  padding: 5px 3px;
  border: 1px solid rgb(85, 105, 212, 0.5);
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 105%;
}
@media (max-width: 1000px) {
  .calctooltip .tooltiptext {
    width: 150px;
    top: 100%;
    left: 50%;
    margin-left: -75px; /* Use half of the width (150/2 = 75), to center the tooltip */
  }
}

.calctooltip:hover .tooltiptext {
  visibility: visible;
}

.textareaAnswer {
  font-family: "Courier New", Courier, monospace;
  tab-size: 1;
  margin-bottom: 1em;
  max-width: 422px;
  width: 100%;
}
@media (max-width: 1200px) {
  .textareaAnswer {
    font-size: small;
  }
}

.bluebox {
  /* For strength calculators (Lewis) */
  background-color: #f0f0f0;
  padding: 10px;
}
.dependentfactor {
  /* For strength calculators (Lewis) */
  background-color: #e0e0e0;
  padding: 10px;
  margin-bottom: 10px;
}

.cButtonBlock {
  margin: 2em 0 1em;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 422px;
}
.calculator textarea {
  width: 100%;
}

.calcButton,
.normButton {
  display: inline-block;
  padding: var(--button-padding);
  box-shadow: none;
}
.normButton {
  background-color: white;
  border: 1px solid rgba(59, 126, 161, 1);
  color: rgba(59, 126, 161, 1);
}
.normButton:hover {
  background: rgba(59, 126, 161, 0.2);
}

.saveButton {
  width: auto;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  border: 1px solid rgba(3, 36, 80, 0.5);
  color: rgb(3, 36, 80, 0.8);
  padding: var(--button-padding);
  box-shadow: none;
}
.saveButton:hover {
  background-color: rgb(3, 36, 80, 0.1);
}

.saveButtonBlock {
  margin: 1em 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 40px;
}
.saveButtonBlock input {
  border: 1px solid lightgray;
  padding: 4px 10px;
}

.loadBox {
  background: #eee;
  padding: 10px 20px 20px;
  margin: -20px -20px 20px -20px;
}
.loadBox .flex {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 40px;
}
.load-input {
  display: flex;
  gap: 10px;
  align-items: center;
}
.loading-message,
.save-message {
  margin-top: 10px;
  font-size: 0.9em;
  font-weight: bold;
}
.save-message.error,
.loading-message {
  color: rgb(249, 0, 10, 0.7);
}

form.calculator {
  border-right: 1px solid lightgray;
  width: 100%;
}
@media only screen and (max-width: 1000px) {
  form.calculator {
    border-right: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/calculators/calc-styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;;EAEjB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,YAAY;IACZ,SAAS;IACT,SAAS;IACT,kBAAkB,EAAE,8DAA8D;EACpF;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["label {\r\n  display: block;\r\n  font-size: 0.9em;\r\n  font-weight: 500;\r\n  margin-bottom: 0.2em;\r\n}\r\nselect {\r\n  padding: 6px 10px;\r\n  border: 1px solid lightgray;\r\n  border-radius: var(--border-radius);\r\n}\r\n.buttonSpacer {\r\n  width: 200px;\r\n  display: inline-block;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.buttonSpacerHalf {\r\n  width: 100px;\r\n  display: inline-block;\r\n}\r\n\r\n@media (max-width: 1000px) {\r\n  label {\r\n    text-align: left;\r\n  }\r\n  .unitslabel {\r\n    width: 40px;\r\n  }\r\n  .buttonSpacer {\r\n    width: 5px;\r\n  }\r\n}\r\n\r\n.radioLabel {\r\n  display: inline-block;\r\n  width: fit-content;\r\n  margin-left: 5px;\r\n}\r\n.radioButton {\r\n  vertical-align: middle;\r\n}\r\n\r\n.unitslabel {\r\n  display: block;\r\n  width: fit-content;\r\n}\r\n.required {\r\n  color: rgb(249, 0, 10, 0.7);\r\n  margin-left: 2px;\r\n}\r\n.inputbox {\r\n  border: 1px solid lightgray;\r\n}\r\nselect.inputbox {\r\n  padding: 2px 10px 2px 4px;\r\n}\r\n.checkbox-wrapper {\r\n  margin: 5px 0 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n.checkbox-wrapper label {\r\n  color: #555;\r\n}\r\n\r\n.calctooltip {\r\n  position: relative;\r\n  display: inline-block;\r\n  border-bottom: 1px dotted black;\r\n  margin-left: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.calctooltip .tooltiptext {\r\n  visibility: hidden;\r\n  width: 150px;\r\n  background-color: #f4f5fa;\r\n  color: black;\r\n  text-align: center;\r\n  border-radius: var(--border-radius);\r\n  padding: 5px 3px;\r\n  border: 1px solid rgb(85, 105, 212, 0.5);\r\n  font-size: 0.8rem;\r\n\r\n  /* Position the tooltip */\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: -5px;\r\n  right: 105%;\r\n}\r\n@media (max-width: 1000px) {\r\n  .calctooltip .tooltiptext {\r\n    width: 150px;\r\n    top: 100%;\r\n    left: 50%;\r\n    margin-left: -75px; /* Use half of the width (150/2 = 75), to center the tooltip */\r\n  }\r\n}\r\n\r\n.calctooltip:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.textareaAnswer {\r\n  font-family: \"Courier New\", Courier, monospace;\r\n  tab-size: 1;\r\n  margin-bottom: 1em;\r\n  max-width: 422px;\r\n  width: 100%;\r\n}\r\n@media (max-width: 1200px) {\r\n  .textareaAnswer {\r\n    font-size: small;\r\n  }\r\n}\r\n\r\n.bluebox {\r\n  /* For strength calculators (Lewis) */\r\n  background-color: #f0f0f0;\r\n  padding: 10px;\r\n}\r\n.dependentfactor {\r\n  /* For strength calculators (Lewis) */\r\n  background-color: #e0e0e0;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.cButtonBlock {\r\n  margin: 2em 0 1em;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  max-width: 422px;\r\n}\r\n.calculator textarea {\r\n  width: 100%;\r\n}\r\n\r\n.calcButton,\r\n.normButton {\r\n  display: inline-block;\r\n  padding: var(--button-padding);\r\n  box-shadow: none;\r\n}\r\n.normButton {\r\n  background-color: white;\r\n  border: 1px solid rgba(59, 126, 161, 1);\r\n  color: rgba(59, 126, 161, 1);\r\n}\r\n.normButton:hover {\r\n  background: rgba(59, 126, 161, 0.2);\r\n}\r\n\r\n.saveButton {\r\n  width: auto;\r\n  display: inline-block;\r\n  margin-left: 5px;\r\n  margin-right: 5px;\r\n  background-color: white;\r\n  border: 1px solid rgba(3, 36, 80, 0.5);\r\n  color: rgb(3, 36, 80, 0.8);\r\n  padding: var(--button-padding);\r\n  box-shadow: none;\r\n}\r\n.saveButton:hover {\r\n  background-color: rgb(3, 36, 80, 0.1);\r\n}\r\n\r\n.saveButtonBlock {\r\n  margin: 1em 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px 40px;\r\n}\r\n.saveButtonBlock input {\r\n  border: 1px solid lightgray;\r\n  padding: 4px 10px;\r\n}\r\n\r\n.loadBox {\r\n  background: #eee;\r\n  padding: 10px 20px 20px;\r\n  margin: -20px -20px 20px -20px;\r\n}\r\n.loadBox .flex {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px 40px;\r\n}\r\n.load-input {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n.loading-message,\r\n.save-message {\r\n  margin-top: 10px;\r\n  font-size: 0.9em;\r\n  font-weight: bold;\r\n}\r\n.save-message.error,\r\n.loading-message {\r\n  color: rgb(249, 0, 10, 0.7);\r\n}\r\n\r\nform.calculator {\r\n  border-right: 1px solid lightgray;\r\n  width: 100%;\r\n}\r\n@media only screen and (max-width: 1000px) {\r\n  form.calculator {\r\n    border-right: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
